import Index from "@/Pages/GestaoDeAtendimentosCAEE/index.vue";
import NewCreateGestaoDeCAEE from "@/Pages/GestaoDeAtendimentosCAEE/NewCreateGestaoDeCAEE.vue";
import relatorioCAEE from "@/Pages/GestaoDeAtendimentosCAEE/relatorioCAEE.vue";

export default [
  {
    path: "/gestoes-de-atendimentos-caee",
    name: "gestoesDeAulasCAEE",
    component: Index,
  },
  {
    path: "/gestoes-de-atendimentos-caee-create",
    name: "gestoesDeAulasCAEE.newEdit",
    component: NewCreateGestaoDeCAEE,
    props: { editing: false },
  },
  {
    path: "/gestoes-de-atendimentos-caEE/edit/:gestaoDeAulasId",
    name: "gestoesDeAulasCAEE.edit",
    component: NewCreateGestaoDeCAEE,
    props: { editing: true },
  },
  {
    path: "/gestoes-de-atendimentos-caee-relatorio/:gestaoId",
    name: "gestoesCAEERelatorio.newEdit",
    component: relatorioCAEE,
  },
];
